export default "__VITE_ASSET__ee801163__"